"use strict";
import $ from "jquery";
import "tabs";

function init(scope) {
    $(scope).tabs({
        tabPaginationClass: ".module-tabs__list-pagination",
        tabPaginationList: ".module-tabs__list",
        tabPaginationContainer: ".module-tabs__list-container",
        tabContent: ".module-tabs__item",
        tabPaginationItems: 6,
        tabContentWrapper: ".module-tabs__item-container",
        tabScrollClass: ".module-tabs__action",
    });

    $(".module-tabs__item .js-toggler").each(function () {
        $(this).on("click", function () {
            const target = $(this).data("togglerObj");
            let height = parseInt(
                $(this)
                    .parents(".module-tabs")
                    .find(".module-tabs__tab-container")
                    .css("height"),
                10,
            );
            height = $(target).hasClass("TabsOverflow-active")
                ? height - $(target).height()
                : height + $(target).height();

            $(target).toggleClass("TabsOverflow-active");

            $(this)
                .parents(".module-tabs")
                .find(".module-tabs__tab-container")
                .animate({ height: height });
        });
    });

    $(".js-toggler").on("click", function () {
        const elm = $(this).data("togglerObj");
        $(elm).addClass("active");
    });
}

function timeline(scope) {
    $(scope).each(function () {
        const parrent = $(this);

        $(this)
            .find(".timeline__list-pagination")
            .on("click", function () {
                const tabsId = $(this).data("timeline");

                parrent
                    .find(".timeline__list-pagination.active")
                    .toggleClass("active");
                parrent
                    .find(".timeline__tab-item.active")
                    .toggleClass("active");
                $(this).toggleClass("active");
                parrent
                    .find(
                        `.timeline__tab-item-content[data-timeline=${tabsId}]`,
                    )
                    .parent()
                    .toggleClass("active");

                $(this)
                    .parents(".module-tabs__tab-container")
                    .animate({
                        height:
                            parrent
                                .parents(".module-tabs__item")
                                .outerHeight() + 75,
                    });
            });

        $(this).find(".timeline__list-pagination").first().addClass("active");
        $(this).find(".timeline__tab-item").first().addClass("active");
    });
}

export default {
    init,
    timeline,
};
